<div class="mobile-layout">
    <app-topbar></app-topbar>
    <div class="main-content-mobile">
        <app-map-mobile class="map-container-mobile"></app-map-mobile>
    </div>
    <app-footer></app-footer>
</div>